import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18n";

import MapboxMapComponent from "./MapboxMapComponent";

import { fetchBusStation, fetchMetroStation } from "../../data/fetchInfoData";

import config from "config";
import busStopIcon from ".././../../../../assets/images/Synchro/icons/bus-stop.png";
import trainStationIcon from "../../../../../assets/images/Synchro/icons/train.png";
import busLocationIcon from "../../../../../assets/images/Synchro/icons/bus-location.png";
import airportLocationIcon from "../../../../../assets/images/Synchro/icons/airport-location.png";

const getKtelData = () => ({
  type: "FeatureCollection",
  features: [
    {
      id: 30000,
      type: "Feature",
      properties: {
        name: "KTEL",
        displayMessage: `<div>${i18n.t("trafficMonitoring.infohub.map.ktelPopup")}</div>`,
        icon: "icon-set-icon-bus-stop-layer",
      },
      geometry: {
        type: "Point",
        coordinates: [22.90204, 40.65729],
      },
    },
  ],
});

const getAirportData = () => ({
  type: "FeatureCollection",
  features: [
    {
      id: 40000,
      type: "Feature",
      properties: {
        name: i18n.t("trafficMonitoring.infohub.map.airport"),
        displayMessage: `<div>${i18n.t("trafficMonitoring.infohub.map.airportPopup")}</div>`,
        icon: "icon-set-icon-bus-stop-layer",
      },
      geometry: {
        type: "Point",
        coordinates: [22.97753, 40.52527],
      },
    },
  ],
});

function InfoHubMap() {
  const { t } = useTranslation();
  const [busStation, setBusStation] = useState(null);
  const [metroStation, setMetroStation] = useState(null);

  useEffect(() => {
    fetchBusStation().then((data) => setBusStation(data));
  }, []);

  useEffect(() => {
    fetchMetroStation().then((data) => setMetroStation(data));
  }, []);

  const layers = useMemo(() => {
    if (!busStation || !metroStation) return [];

    return [
      {
        id: "icon-bus-stop-layer",
        name: t("trafficMonitoring.infohub.map.busStations"),
        visible: true,
        source: {
          type: "geojson",
          data: busStation || { type: "FeatureCollection", features: [] },
        },
        layer: ["IconLayer"],
        layerStyle: {
          useSourceIcon: false,
          setIcon: busStopIcon,
          iconSize: 0.8,
        },
        clusterStyle: {
          isCluster: true,
          clusterColor: "#ff8800",
          clusterRadius: 40,
          clusterTextSize: 12,
        },
        canHover: true,
        canClick: true,
      },
      {
        id: "icon-metro-layer",
        name: t("trafficMonitoring.infohub.map.subwayStations"),
        visible: true,
        source: {
          type: "geojson",
          data: metroStation || { type: "FeatureCollection", features: [] },
        },
        layer: ["IconLayer"],
        layerStyle: {
          useSourceIcon: false,
          setIcon: trainStationIcon,
          iconSize: 0.8,
        },
        canHover: true,
        canClick: true,
      },
      {
        id: "icon-ktel-layer",
        name: "KTEL",
        visible: true,
        source: {
          type: "geojson",
          data: getKtelData(),
        },
        layer: ["IconLayer"],
        layerStyle: {
          useSourceIcon: false,
          setIcon: busLocationIcon,
          iconSize: 1.4,
        },
        canHover: true,
        canClick: true,
      },
      {
        id: "icon-airport-layer",
        name: t("trafficMonitoring.infohub.map.airport"),
        visible: true,
        source: {
          type: "geojson",
          data: getAirportData(),
        },
        layer: ["IconLayer"],
        layerStyle: {
          useSourceIcon: false,
          setIcon: airportLocationIcon,
          iconSize: 1.4,
        },
        canHover: true,
        canClick: true,
      },
    ];
  }, [busStation, metroStation, t]);

  if (!layers.length) return null;

  const mapUIConfig = {
    // UI Controls
    id: "layers-map",

    // Feature toggles
    displayControlPanel: true,
    displayLayerList: true,
    display3DToggle: true,
    displayFilterPanel: true,
    displayLegend: true,
    displayOpacityControl: true,
    displayZoomControl: true,

    // Map Style (default)
    defaultMapStyle: "3D", // or "2d"

    // Default map view settings
    map: {
      center: [22.9527, 40.6253],
      zoom: 11, // Zoom level
      pitch: 0, // Tilt (0 is top-down, 60 is tilted 3D)
      bearing: 0, // Rotation (0 is north-up)
      mapToken: config.MAPBOX_ACCESS_TOKEN_3D,
      style: {
        map2D: "mapbox://styles/mapbox/dark-v11",
        map3D: config.MAP_3D,
      },
    },
  };

  return <MapboxMapComponent layers={layers} mapUIConfig={mapUIConfig} />;
}

export default InfoHubMap;
